<template>
  <v-app>
    <v-container>
      <v-row
        class="d-flex"
      >
        <v-card
          tile
          class="mx-auto px-2"
          style="min-width: 300px; max-width: 500px"
        >
          <v-card
            flat
            class="mx-2"
          >
            <v-form>
              <v-text-field
                v-model="form.username"
                label="Email"
                class="lbl-textbox"
              ></v-text-field>
              <v-text-field
                v-model="form.password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required]"
                :type="showPassword ? 'text' : 'password'"
                name="input-10-1"
                label="Password"
                counter
                @click:append="showPassword = !showPassword"
                @keyup.enter="doLogin"
              ></v-text-field>
            </v-form>
          </v-card>
          <v-card
            v-if="loginError.length > 0"
            flat
            class="card-full-width"
          >
            <v-alert
              dense
              outlined
              type="error"
            >
              {{ loginError }}
            </v-alert>
          </v-card>
          <v-card
            class="d-flex"
            flat
          >
            <a
              href="/#/password-reset"
              class="mr-0 grey--text text--darken-3"
              rel="noopener"
            >
              Forgot password?
            </a>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              class="mr-auto"
              @click="doLogin"
            >
              Login
            </v-btn>
          </v-card>
          <v-card
            class="d-flex"
            flat
          >
            <a
              href="/#/register"
              class="mr-0 grey--text text--darken-3"
              rel="noopener"
            >
              No account? register
            </a>
            <v-spacer></v-spacer>
          </v-card>
          <v-overlay :value="formOverlay">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        </v-card>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import {
    AUTH_LOGIN,
  } from '../../store/actions.types'

  export default {
    name: 'Login',

    components: {
    },

    data: () => ({
      showPassword: false,
      isLoggingInManual: false,
      expandOnHover: false,
      formOverlay: false,
      form: {
        username: '',
        password: '',
      },
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
      loginError: '',
    }),
    computed: {
      ...mapGetters(['isLoggedIn']),
    },
    watch: {
      isLoggedIn (n, o) {
        this.$router.push('/app')
      },
    },
    methods: {
      ...mapActions({
        login: AUTH_LOGIN,
      }),
      async doLogin () {
        this.formOverlay = true

        console.log('doing login!')
        const success = await this.login({ email_address: this.form.username, password: this.form.password })
        if (!success) {
          this.loginError = 'Invalid username and/or password'
        } else {
          this.loginError = ''
        }
        this.formOverlay = false
      },
    },
    mounted () {
      if (this.isLoggedIn) {
        this.$router.push('/')
      }
    },
  }
</script>

<style scoped>

</style>
